// Similar to jQuery.fn.closest, navigates from a given node upwards returning
// the first node that matches the given predicate function
//
export function closest(el, predicate) {
  do if (predicate(el)) return el;
  while ((el = el && el.parentNode));
}
